import { createEvent } from 'effector';

const focused = createEvent<FocusEvent>();

window.addEventListener('focus', focused);

export const browserEvents = {
  focused
}